import * as React from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

import { localStorage } from '@gitbook/util-local-storage';

const MAX_RECENT_SEARCHES = 5;

/**
 * Atom to store the recent searches done by the user.
 */
const recentSearchesAtom = atom<string[]>({
    key: 'recentSearches',
    default: [],
    effects: [localStorage.recoilEffect('@recoil/recentSearches', [])],
});

/**
 * List the recent searches.
 */
export function useRecentSearches(): string[] {
    return useRecoilValue(recentSearchesAtom);
}

/**
 * Add a new search to the recent searches.
 */
export function useRegisterRecentSearch(query: string) {
    const setRecentSearches = useSetRecoilState(recentSearchesAtom);

    React.useEffect(() => {
        if (!query) {
            return;
        }

        const timeout = setTimeout(() => {
            setRecentSearches((recentSearches) => {
                if (recentSearches.includes(query)) {
                    return recentSearches;
                }

                return [query, ...recentSearches.slice(0, MAX_RECENT_SEARCHES - 1)];
            });
        }, 3000);

        return () => clearTimeout(timeout);
    }, [query]);
}
